import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

interface BannerProps {
  small?: boolean;
}

const Banner = ({ small = false }: BannerProps) => {
  const { t } = useTranslation();

  return (
    <div className="relative text-center bg-[#00122e]">
      <Link to="/">
        <div className="h-[50px] flex align-center justify-center">
          <img
            src="/img/FordLogo.png"
            className="w-[78px] object-contain"
            alt="Ford"
          />
        </div>
        <img
          src={t("common.bannerImg")}
          alt={t("common.title")}
          style={small ? { width: "65%" } : {}}
        />
      </Link>
    </div>
  );
};

export default Banner;
